export default __webpack_public_path__ + "static/media/plan.d6fcf8a7.jpg";